import Enumeration from 'Lib/utilities/Enumeration';

const Features = new Enumeration([
	{ id: 1, key: 'Pods', name: 'Pods' },
	{ id: 2, key: 'InternalMaintenance', name: 'Internal Maintenance' }
]);

export default Features;
